import {LanguageUtility} from '../../utilities/language-utility';
import {HelperOptions} from 'handlebars';

/**
 * Helper for getting a translated language label.
 *
 * @param {string} key Language key to translate
 * @param {HelperOptions} options Helper options
 * @returns {string} Translated label
 * @author Philipp Seiler <sep@earlybird.at>
 */
const translate = (key: string, options: HelperOptions): string => {
  if (options.hash.hasOwnProperty('key') && options.hash.key) {
    return options.hash.key;
  }
  return LanguageUtility.translate(key);
};
export default translate;
